import styled from 'styled-components/native';

export const TouchableHighlight = styled.TouchableHighlight``;
